// Brand names and marks, never translated.
export const LLM_PROVIDERS = {
  openai: { name: 'OpenAI', icon: 'i-ri-openai-fill' },
  anthropic: { name: 'Anthropic', icon: 'i-ri-anthropic-line' },
  gemini: { name: 'Gemini', icon: 'i-woot-gemini' },
};

export const providerName = provider =>
  LLM_PROVIDERS[provider]?.name || provider;

// Which of the account's LLMs a feature's calls go out on: the same rule as Llm::CredentialResolver.
// `credentials` come oldest first, as the API lists them; `feature` is a preferences entry, with
// the provider of the model it runs and the LLM it was pointed at, if any.
export const resolveFeatureCredential = (credentials, feature) => {
  if (!feature?.provider) return null;

  const chosen = credentials.find(
    credential => String(credential.id) === String(feature.credential_id)
  );
  if (chosen?.provider === feature.provider) return chosen;

  return (
    credentials.find(credential => credential.provider === feature.provider) ||
    null
  );
};

// The oldest LLM of a provider is the one that provider's models use unless a feature picks another.
export const isProviderDefault = (credentials, credential) =>
  credentials.find(item => item.provider === credential.provider)?.id ===
  credential.id;
